import { createSlice } from "@reduxjs/toolkit";

const initialState = () => ({
  errmsg: null,
  result: {
    id: "",
    name: "",
    desp: "",
    criFormPage: null,
    entryFormPage: null,
    recCount: null,
    rowsOfPage: null,
    resultColumns: [
      {
        displayFlex: null,
        sortCondition: null,
        caption: "",
        captionGroup: null,
        key: "",
        nextLink: "",
        seq: 1,
        list: [],
      },
      {
        displayFlex: null,
        sortCondition: null,
        caption: "",
        captionGroup: null,
        key: "",
        nextLink: "",
        seq: 1,
        list: [],
      },
    ],
  },
  errcode: null,
});

export const filterReducer = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilterBy: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = filterReducer;
export const { setFilterBy } = actions;

export default reducer;
